import "./FieldTag.scss"
import {useState} from "react";

export interface FieldTagProps {
    id?: string
    disabled?: boolean
    label?: string
    value?: string[]
    required?: boolean
    invalid?: boolean
    help?: string
    emptyDisplay?: string
    onChange?: (value: string[]) => void
    onBlur?: () => void
    createTagOnEnter?: boolean,
    inputTransform?: (value: string) => string
    createTag?: (e: React.FormEvent<HTMLInputElement>) => boolean
    tagCreate?: (e: React.FormEvent<HTMLInputElement>) => string[]
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void
}

const Keys = {
    BACKSPACE: "Backspace",
    TAB: "Tab",
    ENTER: "Enter",
    ESC: "Escape",
    DEL: "Delete"
}

function FieldTag({
                      id,
                      required,
                      label,
                      invalid,
                      disabled,
                      onChange,
                      onInput,
                      inputTransform,
                      createTag,
                      tagCreate,
                      createTagOnEnter,
                      help,
                      value
                  }: FieldTagProps) {

    function defaultTagCreate(e: React.FormEvent<HTMLInputElement>): string[] | undefined {
        if (!value || !onChange) {
            return
        }
        const input = e.currentTarget;
        const val = input.value;
        if (val && value.indexOf(val) === -1) {
            const copied = value?.slice()
            copied?.push(val)
            input.value = ''
            return copied
        }
    }

    const tagCreator = tagCreate ? tagCreate : defaultTagCreate
    const [inputLength, setInputLength] = useState(0)

    return <>
        <div
            id={id}
            className={`field cmp-field-tag ${required ? 'required' : ''}`}
        >
            <label className="label">{label}</label>
            <div className="control">
                <label
                    className={`input is-fullwidth ${invalid ? 'is-danger' : ''}`}
                >
                    <input
                        className={`length-${inputLength}`}
                        disabled={disabled}
                        style={{
                            width: `${Math.min((inputLength) + 0.5, 10)}em`
                        }}
                        onKeyUp={e => {
                            if (onChange && createTagOnEnter && e.key === Keys.ENTER) {
                                const newTags = tagCreator(e)
                                if (newTags) {
                                    onChange(newTags)
                                    setInputLength(0)
                                }
                            }
                        }}
                        onInput={e => {
                            if (inputTransform) {
                                const input = e.currentTarget;
                                const start = input.selectionStart;
                                const end = input.selectionEnd;
                                const value = input.value
                                const val = inputTransform(value)
                                if (value !== val) {
                                    input.value = val
                                    setTimeout(() => {
                                        input.setSelectionRange(start, end)
                                    }, 1)
                                }
                            }
                            if (createTag && value && onChange && createTag(e)) {
                                const newTags = tagCreator(e)
                                if (newTags) {
                                    onChange(newTags)
                                }
                            }
                            setInputLength(e.currentTarget.value.length)
                            onInput && onInput(e)
                        }}
                    />
                    {value && <div className={"tag-value"}>
                        {value.map((el, index) => {
                            return <span key={index} className={`tag ${disabled ? 'is-light' : 'is-info'}`}>{el}
                                <button
                                    onClick={(ev) => {
                                        ev.preventDefault()
                                        ev.stopPropagation()
                                        const copied = value?.slice()
                                        copied?.splice(value?.indexOf(el), 1)
                                        !disabled && onChange && onChange(copied)
                                    }}
                                    className="delete is-small"></button>
                            </span>
                        })}
                    </div>}
                    {/*input um zu schreiben mit methode zur extraction von tags*/}
                </label>
            </div>
            <p className={`help ${invalid ? 'is-danger' : ''}`}>{help}</p>
        </div>
    </>
}

export {
    FieldTag
}
